/** Strip trailing slash from API base URL. */
export function normalizeApiUrl(apiUrl: string): string {
  return apiUrl.replace(/\/$/, "");
}

/** Socket.IO connects to the gateway origin (no `/v1` path). */
export function socketOriginFromApiUrl(apiUrl: string): string {
  const url = new URL(normalizeApiUrl(apiUrl));
  return url.origin;
}
